import { StyleSheet } from "react-native";

export default StyleSheet.create({
  paynowBtnView: {
    justifyContent: "center",
    alignItems: "center",
  },

  payBtn: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#ed705b",
    width: 159,
    height: 48,
    color: "white",
    borderRadius: 65,
  },

  txtPayNow: {
    color: "white",
    fontSize: 16,
    fontFamily: "SFProText",
  },
});
